import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "sticker-gallery__chip-tag-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "sticker-gallery__no-results-text" }

import { computed, onBeforeMount, ref } from 'vue'
import { useStickerGalleryStore } from '@/store/gallery/sticker-store'
import LazyImage from '@/components/gallery/LazyImage.vue'
import MosaicGrid from '@/components/gallery/MosaicGrid.vue'
import { GalleryItem } from '@/store/gallery/types'
import ChipTag from '@/components/gallery/ChipTag.vue'
import FileSelector from '@/components/common/FileSelector.vue'
import { logoAccept } from '@/static/file-types'
import { useApplicationStore } from '@/store/application-store'
import CloudUploadIcon from '@/assets/CloudUploadIcon.svg'
import { storeToRefs } from 'pinia'
import GtmHelper from '@/analytics/gtm-helper'
import { useFileValidator, ValidationError } from '@/composables/UseFileValidator'
import useImageStates from '@/composables/UseImageStates'


export default /*#__PURE__*/_defineComponent({
  __name: 'StickerGallery',
  setup(__props) {

const gtmHelper = GtmHelper.getInstance()
const applicationStore = useApplicationStore()
const stickerGalleryStore = useStickerGalleryStore()
const { selectedCollection } = storeToRefs(stickerGalleryStore)

const stickerGallery = ref<HTMLElement | null>(null)

const hasResults = computed(() => stickerGalleryStore.items.length > 0)

const { validateStickerFile } = useFileValidator()
const { addLogoSticker, addSticker } = useImageStates()

onBeforeMount(() => {
  // Fetch the default collection media
  stickerGalleryStore.fetchCollections().then(() => retrieveActiveCollection('Emoji'))
})

const onDrag = (event: DragEvent, sticker: GalleryItem) => {
  event.dataTransfer?.setData('src', sticker.source[0].src)
}

const uploadLogo = (file: File) => {
  try {
    validateStickerFile(file)
    addLogoSticker(URL.createObjectURL(file), file.name)
    gtmHelper.triggerLogoUploadGtmEvent(file.size)
  } catch (e) {
    if (e instanceof ValidationError) {
      applicationStore.pushSnackbarMessage({
        header: e.title,
        text: e.message,
        state: 'error'
      })
    }
  }
}

// Threshold for when to start fetching the next page, might change later
const threshold = 0.9

const onIntersect = (index: number) => {
  if (index === Math.floor((stickerGalleryStore.items.length - 1) * threshold)) {
    stickerGalleryStore.nextPage()
  }
}

const addStickerToCanvas = (sticker: GalleryItem) => {
  if (applicationStore.isStickerLoading) {
    return
  }
  addSticker(sticker.source[0].src)
}

const onSelectTag = (title: string) => {
  if (title !== selectedCollection.value?.title) {
    retrieveActiveCollection(title)
  }
}

const retrieveActiveCollection = (title: string) => {
  const collection = stickerGalleryStore.collections.find((collection) => collection.title === title)
  if (collection) {
    // Asynchronous call
    stickerGalleryStore.fetchByCollection(collection)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "stickerGallery",
    ref: stickerGallery,
    class: "sticker-gallery"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(FileSelector, {
        accept: _unref(logoAccept),
        onFileSelected: uploadLogo
      }, {
        default: _withCtx(() => [
          _createVNode(ChipTag, {
            text: "Upload logo",
            "has-fill": "",
            "has-no-border": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CloudUploadIcon))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["accept"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stickerGalleryStore).collections, (collection) => {
        return (_openBlock(), _createBlock(ChipTag, {
          text: collection.title,
          key: collection.id,
          "is-active": _unref(selectedCollection)?.title === collection.title,
          onClick: ($event: any) => (onSelectTag(collection.title))
        }, null, 8, ["text", "is-active", "onClick"]))
      }), 128))
    ]),
    _withDirectives(_createVNode(MosaicGrid, {
      class: "sticker-gallery__results",
      items: _unref(stickerGalleryStore).items,
      "num-cols": 2,
      gap: 4
    }, {
      default: _withCtx(({ item, index }) => [
        _createElementVNode("div", {
          class: "sticker-gallery__results-item",
          onClick: ($event: any) => (addStickerToCanvas(item))
        }, [
          _createVNode(LazyImage, {
            class: "sticker-gallery__results-item-contents",
            src: item.preview.imageSource.src,
            "parent-container": stickerGallery.value,
            onViewportIntersect: ($event: any) => (onIntersect(index)),
            onDragstart: ($event: any) => (onDrag($event, item))
          }, null, 8, ["src", "parent-container", "onViewportIntersect", "onDragstart"])
        ], 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["items"]), [
      [_vShow, _unref(hasResults)]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, " No search results ", 512), [
      [_vShow, !_unref(hasResults)]
    ])
  ], 512))
}
}

})